// Reusable widget components used across many pages
import { defineAsyncComponent } from 'vue'

export default {
  Components: defineAsyncComponent(() => import('../components.vue')),
  DynamicProgressCircular: defineAsyncComponent(
    () => import('../dynamic_progress_circular.vue')
  ),
  ExpandableInfo: defineAsyncComponent(() => import('../expandable_info.vue')),
  SearchableTreeview: defineAsyncComponent(
    () => import('../searchable_treeview.vue')
  ),
  SimpleDialog: defineAsyncComponent(() => import('../simple_dialog.vue')),
  Tooltip: defineAsyncComponent(() => import('../tooltip.vue')),
  UserCard: defineAsyncComponent(() => import('../common/user_card.vue')),
  UserAccessLevel: defineAsyncComponent(
    () => import('../user_access_level.vue')
  ),
  VDatePickerInput: defineAsyncComponent(
    () => import('../v_date_picker_input.vue')
  ),
  VDateRangePicker: defineAsyncComponent(
    () => import('../v_date_range_picker.vue')
  ),
  VHighcharts: defineAsyncComponent(() => import('../v_highcharts.vue')),
  VSearchableSelect: defineAsyncComponent(
    () => import('../v_searchable_select.vue')
  )
}
